import './Ticktock.less';
export { default } from './Ticktock.js';